export enum actionTypes {
    UPDATE_LOYALTY_POINTS = 'LOYALTY_POINTS:UPDATE'
}
